// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__H8qcn","counter_icon":"Counter_counter_icon__gjl5B","counter_text":"Counter_counter_text__s5Kq5","counter_subText":"Counter_counter_subText__vFzOb"};